import React, { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '84px',
    height: '48px',
    fontFamily: `'Open Sauce One', sans-serif`,
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    borderRadius: '8px',
  },
  primary: {
    background: '#F09242',
    color: '#F6F8FA',
  },
  secondary: {
    background: '#FFFFFF1A',
    color: '#F6F8FA',
  },
}));

type Props = {
  onClick: () => void;
  className?: string;
  isSecondary?: boolean;
};

export const TableActionButton: React.FC<PropsWithChildren<Props>> = ({
  className,
  children,
  isSecondary,
  onClick,
}) => {
  const classes = useStyles();

  return (
    <button
      onClick={onClick}
      className={classNames(
        classes.button,
        isSecondary ? classes.secondary : classes.primary,
        className
      )}
    >
      {children}
    </button>
  );
};
